// specialRequirementsOptions.js

export const specialRequirementsOptions = [
      { label: "Allergy - please specify in message", value: "Allergy - please specify in message" },
      { label: "Birthday - please advise name in message", value: "Birthday - please advise name in message" },
      { label: "Dietary Requirement - please specify in message", value: "Dietary Requirement - please specify in message" },
      { label: "Highchair (Kinderstuhl)", value: "Highchair (Kinderstuhl)" },
      { label: "Marriage Anniversary", value: "Marriage Anniversary" },
      { label: "Prozentbuch", value: "Prozentbuch" },
      { label: "Passport Gourmand", value: "Passport Gourmand" },
      { label: `Swisstours Voucher - please specify "TRANSACTION NO"`, value: "Swisstours Voucher" },
      { label: "Zwei für eins", value: "Zwei für eins" },
      { label: "Others", value: "Others" }
];


export const NumberofGuests = [
      ...Array.from({ length: 10 }, (_, idx) => ({
            label: `${idx + 1}`,
            value: `${idx + 1}`,
      })),
      { label: "10+", value: "10+" },
];

